import { createSelector } from "@reduxjs/toolkit";

export const selectRosterOwnerLovList = createSelector(
  (state) => state.api.queries["fetchRosterOwnerLov(undefined)"]?.data,
  (data) => data || []
);

export const selectProtocolList = createSelector(
  (state) => state.api.queries["fetchProtocolLov(undefined)"]?.data,
  (data) => data || []
);

export const selectCredTypeList = createSelector(
  (state) => state.api.queries["fetchCredTypeLov(undefined)"]?.data,
  (data) => data || []
);

export const selectBrowserLeadOrgList = createSelector(
  (state) => state.api.queries["fetchBrowserLeadOrgLov(undefined)"]?.data,
  (data) => data || []
);
